import { TabItem } from ".yalc/bimui/dist/external";
import { useCallback, useEffect, useState } from "react";
import localStore from "./local-store";
import { File } from "@/declare/interface/project/file"

export interface TabItemProps extends TabItem {

}

export interface NavigationStatus {
    currentProjectUuid: string; // 当前项目 ID
    setCurrentProjectUuid: React.Dispatch<React.SetStateAction<string>>; // 设置当前项目 ID 的方法
    isDemoUser: boolean; // 是否为演示用户
    setIsDemoUser: React.Dispatch<React.SetStateAction<boolean>>; // 设置是否为演示用户的方法

    tabs: TabItemProps[], // 页签
    setTabs: React.Dispatch<React.SetStateAction<TabItemProps[]>>, // 设置全部页签
    registTab: (tab: TabItemProps) => void, // 注册一个页签
    removeTab: (key: string) => void, // 移除一个页签
    activeTabKey: string, // 当前激活的页签
    setActiveTabKey: React.Dispatch<React.SetStateAction<string>> // 设置当前激活的页签
    currentSectionType: number; // 新增的截面类型
    setCurrentSectionType: React.Dispatch<React.SetStateAction<number>>; // 设置截面类型的方法
    currentMaterialType: number; // 新增的材料类型
    setCurrentMaterialType: React.Dispatch<React.SetStateAction<number>>; // 设置类型类型的方法
    currentSelectUser: string; // 当前查看个人任务列表
    setCurrentSelectUser: React.Dispatch<React.SetStateAction<string>>; // 设置当前查看个人任务列表的方法
    clearTabs: () => void
    setTabSave: (tabKey: string, save: boolean) => void
    currentActiveFile: File // 记录用户上次打开的文件路径
    setCurrentActiveFile: (file: File) => void // 设置用户上次打开的文件路径

    setTabsBySidebarKey: (major: string) => TabItemProps[] // 根据sidebarKey设置页签
}

// 导航服务 Hook，用于管理导航状态
export function useNavigationService() {
    const [currentProjectUuid, setCurrentProjectUuid] = useState<string>(); // 当前项目 uuid 状态
    const [isDemoUser, setIsDemoUser] = useState<boolean>(); // 是否为演示用户状态

    const [tabs, setTabs] = useState<TabItemProps[]>(localStore.getCurrentTabs() || []); // 导航页签
    const [activeTabKey, setActiveTabKey] = useState<string>(); // 当前激活的页签


    const [currentSectionType, setCurrentSectionType] = useState<number>(null);    // 用于存储当前激活的截面类型
    const [currentMaterialType, setCurrentMaterialType] = useState<number>(null);    // 用于存储当前激活的材料类型
    const [currentSelectUser, setCurrentSelectUser] = useState<string>(null);    // 用于存储当前激活的用户任务跳转

    const [currentActiveFile, setCurrentActiveFile] = useState<File>(); // 记录用户上次打开的文件路径

    useEffect(() => {
        localStore.setCurrentActiveTabKey(activeTabKey);
    }, [activeTabKey])

    useEffect(() => {
        if (localStore.getCurrentTabs()) {
            setTabs(localStore.getCurrentTabs())
        }
    }, [])

    /**
     * 注册页签
     */
    const registTab = useCallback((tab: TabItemProps) => {
        // 判断是否存在相同页签
        let oldIndex = tabs?.findIndex(item => item.key == tab.key);
        if (oldIndex >= 0) {
            //当旧标签存在时，需要判断名称是否一致，不一致则修改名称
            let old = tabs[oldIndex];
            if (old.value === tab.value) {
                return;
            }
            let newTabs = [...tabs];
            newTabs[oldIndex] = tab;
            setTabs(newTabs);
            return;
        };
        let newTabs = [
            ...tabs,
            tab
        ]
        setTabs([
            ...newTabs
        ])
        localStore.setCurrentTabs(newTabs)
    }, [tabs])

    /**
     * 移除页签
     * @param key 
     */
    const removeTab = (key: string) => {
        let res = tabs?.filter(item => item.key != key) || [];
        setTabs([
            ...res
        ])
        localStore.setCurrentTabs(res)
    }

    /**
     * 设置页签的保存状态
     */
    const setTabSave = (tabKey: string, save: boolean) => {
        tabs.forEach(tab => {
            if (tab.key == tabKey) {
                tab.unSave = !save
            }
        })
        setTabs([...tabs])
    }

    /**
     * 清空页签
     */
    const clearTabs = () => {
        setTabs([])
        localStore.setCurrentTabs([])
        localStore.setCurrentActiveTabKey(null);
        setActiveTabKey(null);
    }

    /**
     * 根据sidebarKey切换页签列表
     */
    const setTabsBySidebarKey = (sidebarKey: string) => {
        let tabs = localStore.getTabsBySidebarKey(sidebarKey) || [];
        setTabs([...tabs]);
        return [...tabs]
    }

    return {
        currentProjectUuid,
        setCurrentProjectUuid,

        isDemoUser,
        setIsDemoUser,

        tabs,
        setTabs,
        registTab,
        removeTab,
        activeTabKey,
        setActiveTabKey,
        currentSectionType, // 暴露截面类型状态
        setCurrentSectionType, // 暴露设置截面类型的方法
        currentMaterialType, // 暴露材料类型状态
        setCurrentMaterialType, // 暴露设置材料类型的方法
        currentSelectUser,
        setCurrentSelectUser,
        clearTabs, // 清空页签
        setTabSave,
        currentActiveFile, // 记录用户上次打开的文件路径
        setCurrentActiveFile, // 设置用户上次打开的文件路径

        setTabsBySidebarKey, // 根据sidebarKey切换页签列表
    } as NavigationStatus
}